<template>
	<div>
   <header class="header_sticky">
		<div class="container">
			<div class="row">
				<div class="col-lg-3 col-6">
					<div id="logo_home">
						<h1><a href="/" title="tkon">tkon</a></h1>
					</div>
				</div>
				<nav class="col-lg-9 col-6">
					<a class="cmn-toggle-switch cmn-toggle-switch__htx open_close" href="#0"><span>Menu mobile</span></a>
					<div class="main-menu">
						<ul>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/' + $i18n.locale)" :href="'/' + $i18n.locale">{{ $t('home') }}</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/' + $i18n.locale + '/about')" :href="'/' + $i18n.locale + '/about'">{{ $t('about_us') }}</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/' + $i18n.locale + '/discovery')" :href="'/' + $i18n.locale + '/discovery'">{{ $t('discovery') }}</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/' + $i18n.locale + '/contact')" :href="'/' + $i18n.locale + '/contact'">{{ $t('contact_us') }}</a>
							</li>
							<li class="submenu">
								<a style="text-decoration: none;" @click="menuClick($event, '/' + $i18n.locale + '/register')" :href="'/' + $i18n.locale + '/register'">{{ $t('register') }}</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</div>
	</header>
	<modal name="hello" width="80%" height="60%" style="background: transparent" @before-close="beforeClose">
		<img src="../assets/images/tkon/popup-illustration.png" style="max-width:100%; max-height:100%;">
		<div class="centered">
			<span class="coming-soon">COMING SOON</span>
			<div class="segera-hadir">
				Segera hadir konsultasi dengan berbagai pakar yang ahli di bidangnya hanya dengan chat kapanpun dimanapun.
			</div>
		</div>
	</modal>
	<el-dialog :visible.sync="dialog.comingSoon">
		<img src="../assets/images/tkon/popup-illustration.png" height="400">
		<div class="centered">
			<span style="font-family: Gotham-Bold; font-size: 35px; color: #fff;">COMING SOON</span>
			<div style="font-family: Gotham-Bold; color: #fff; width: 500px;">
				Segera hadir konsultasi dengan berbagai pakar yang ahli di bidangnya hanya dengan chat kapanpun dimanapun.
			</div>
		</div>
	</el-dialog>
	</div>
</template>
<script>
import $ from 'jquery'
export default {
	name: "Topbar",
	data () {
		return {
			dialog: {
				comingSoon: false
			},
			burger_open: false
		}
	},
	methods: {
		menuClick(event, destination){
			event.preventDefault()
			this.$router.push(destination)
		},
		show () {
			this.$modal.show('hello');
		},
		hide () {
			$('body').removeClass('body_freeze')
			this.$modal.hide('hello');
		},
		toogleBurger(){
			$('a.open_close').on("click", function () {
				this.burger_open = !this.burger_open
				$('.main-menu').toggleClass('show');
				$('.layer').toggleClass('layer-is-visible');
				$('header.static').toggleClass('header_sticky sticky');
				if(this.burger_open){
					$('body').addClass('body_freeze');
				} else {
					$('body').removeClass('body_freeze');
				}
			});
		},
		beforeClose(cb) {
			$('body').removeClass('body_freeze')
			cb()
		},
	},
	mounted(){
		var toggles = document.querySelectorAll(".cmn-toggle-switch");
		for (var i = toggles.length - 1; i >= 0; i--) {
			var toggle = toggles[i];
			toggleHandler(toggle);
		};
		function toggleHandler(toggle) {
			toggle.addEventListener("click", function (e) {
				e.preventDefault();
				(this.classList.contains("active") === true) ? this.classList.remove("active"): this.classList.add("active");
				$('body').removeClass('body_freeze');
			});
		};
		this.toogleBurger()
		$('.submenu').on("click", function(){
			if(this.burger_open){
				$('.main-menu').toggleClass('show');
				$('.layer').toggleClass('layer-is-visible');
				$('header.static').toggleClass('header_sticky sticky');
				$('body').addClass('body_freeze');
				$('.cmn-toggle-switch').removeClass('active')
				this.burger_open = true
			} else {
				$('.main-menu').removeClass('show');
				$('.layer').removeClass('layer-is-visible');
				$('header.static').removeClass('header_sticky sticky');
				$('body').removeClass('body_freeze');
				$('.cmn-toggle-switch').removeClass('active')
				this.burger_open = false
			}
		})
	}
}
</script>

<style>
.centered {
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
.vm--modal {
	background: transparent !important;
	background-color: none !important;
	box-shadow: none !important;
}

@media only screen and (max-width: 600px) {
	.centered {
		position: absolute;
		/* top: 30%; */
		left: 50%;
		transform: translate(-50%, -50%);
	}	
}
</style>


// WEBPACK FOOTER //
// src/core/topbar.vue